import React, { useState } from "react";

import { Popover } from "antd";
import { TbMailForward } from "react-icons/tb";

import { useClient } from "../../hooks/ClientProvider";
import { ModalSendMailOrSms } from "../../pages/home/modals/ModalSendMailOrSms/ModalSendMailOrSms";
import api from "../../services/api";
import { notifyError, notifySucces } from "../../utils/notifications";
import * as S from "./style";
import Can from "../Can";
import { capitalize } from "../../utils/capitalize";

type DuplicatedInvoicePDFModalProps = {
  invoiceId: string;
  dueDate: string;
};

export function DuplicatedInvoicePDFModal({
  invoiceId,
  dueDate,
}: DuplicatedInvoicePDFModalProps) {
  const { client } = useClient();

  const [duplicatedInvoiceId, setDuplicatedInvoiceId] = useState<
    string | undefined
  >(undefined);
  const [isLoading, setIsLoading] = useState(false);

  const onClickToGetDuplicatedInvoicePDF = () => {
    setDuplicatedInvoiceId(invoiceId);
  };

  const onCloseDuplicatedInvoicePDFModal = () => {
    setDuplicatedInvoiceId(undefined);
  };

  // eslint-disable-next-line consistent-return
  const onSubmit = async (mail: string) => {
    try {
      setIsLoading(true);
      const response = await api.post(`duplicated_invoice/${invoiceId}`, {
        clientId: client.client.id,
        email: mail,
        cpf: client.client.cpf,
        dueDate,
        clientName: capitalize(client.client.name),
      });

      const hasCustomError =
        !!response?.statusCode &&
        typeof response.statusCode === "number" &&
        response?.statusCode?.toString()?.at(0) !== "2";

      if (hasCustomError) {
        return notifyError(response.message);
      }

      notifySucces(response.message);
      onCloseDuplicatedInvoicePDFModal();
    } catch (error) {
      const err = error as ErrorMessage;
      notifyError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Can permission="permission_send_duplicated_invoice_to_email">
        <Popover placement="bottom" content="Enviar segunda via por e-mail">
          <S.DuplicatedInvoicePDF
            type="button"
            onClick={onClickToGetDuplicatedInvoicePDF}
          >
            <TbMailForward />
          </S.DuplicatedInvoicePDF>
        </Popover>
      </Can>

      <ModalSendMailOrSms
        isOpen={!!duplicatedInvoiceId}
        onClose={onCloseDuplicatedInvoicePDFModal}
        isSmsEnabled={false}
        clientMail={client?.client?.email}
        onSubmitMail={onSubmit}
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onSubmitSms={() => {}}
        title="Envio de segunda via de fatura por e-mail"
        isSubmitting={isLoading}
      />
    </>
  );
}